import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import "./styles/globals.scss"
import "./styles/variables.scss"
import { I18nextProvider } from 'react-i18next';
import i18n from './utils/translations.ts';
import React from "react"
import useInits from "@/hooks/inits.ts"
const i = useInits()
import * as Sentry from "@sentry/react";
import CommonClass from "@/utils/common.ts";

const prefetches = async () => {
    await i.init_function()
}

prefetches().then(() => {

    if(import.meta.env.MODE !== "development" && CommonClass.general_settings?.sentry_logs?.is_allowed) {
        Sentry.init({
            dsn: import.meta.env.VITE_SENTRY_DSN,
            integrations: [],
            release: import.meta.env.VITE_BUILD_VCS_TAG_LABEL,
            beforeSend(event) {
                const user = CommonClass.sentry_user
                if(user) {
                    event.contexts = {
                        ...event.contexts,
                        user_data: { ...user }
                    }
                }
                return event
            }
        });
    }

    ReactDOM.createRoot(document.getElementById('root')!).render(
        <React.StrictMode>
            <I18nextProvider i18n={i18n}>
                <App />
            </I18nextProvider>
        </React.StrictMode>,
    )
})
